import type { IconData } from '@stacksjs/iconify-core'

export const buttonPlayCircleSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 46.5C11.574 46.5 1.5 36.426 1.5 24S11.574 1.5 24 1.5S46.5 11.574 46.5 24S36.426 46.5 24 46.5m-3.49-32.279c-2.436-.97-4.724.496-5.076 3.094A50 50 0 0 0 15 24c0 2.67.195 4.925.434 6.685c.352 2.598 2.64 4.064 5.076 3.094c1.534-.611 3.547-1.528 6.137-2.904c2.446-1.3 4.378-2.462 5.878-3.446c2.653-1.74 2.653-5.118 0-6.858c-1.5-.984-3.432-2.147-5.878-3.446c-2.59-1.376-4.603-2.293-6.137-2.904\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default buttonPlayCircleSolid
